import { useEffect, useRef, useState } from "react";
import { useIsTouch } from "../lib/useReducedMotion";

// Custom orange circle cursor. Grows and shows a label on [data-cursor] elements.
export function CustomCursor() {
  const isTouch = useIsTouch();
  const dotRef = useRef(null);
  const ringRef = useRef(null);
  const [label, setLabel] = useState("");
  const [active, setActive] = useState(false);

  useEffect(() => {
    if (isTouch) return;
    document.documentElement.classList.add("cursor-none-desktop");

    const pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    const ring = { x: pos.x, y: pos.y };
    let raf;

    const move = (e) => {
      pos.x = e.clientX;
      pos.y = e.clientY;
      if (dotRef.current) {
        dotRef.current.style.transform = `translate(${pos.x}px, ${pos.y}px)`;
      }
      const el = e.target.closest?.("[data-cursor]");
      if (el) {
        setActive(true);
        setLabel(el.getAttribute("data-cursor-label") || "");
      } else {
        setActive(false);
        setLabel("");
      }
    };

    const loop = () => {
      ring.x += (pos.x - ring.x) * 0.18;
      ring.y += (pos.y - ring.y) * 0.18;
      if (ringRef.current) {
        ringRef.current.style.transform = `translate(${ring.x}px, ${ring.y}px)`;
      }
      raf = requestAnimationFrame(loop);
    };

    window.addEventListener("mousemove", move);
    raf = requestAnimationFrame(loop);
    return () => {
      window.removeEventListener("mousemove", move);
      cancelAnimationFrame(raf);
      document.documentElement.classList.remove("cursor-none-desktop");
    };
  }, [isTouch]);

  if (isTouch) return null;

  return (
    <>
      <div
        ref={dotRef}
        className="pointer-events-none fixed left-0 top-0 z-[9998] h-2 w-2 -translate-x-1/2 -translate-y-1/2 rounded-full bg-hars-orange"
        style={{ marginLeft: "-4px", marginTop: "-4px" }}
        aria-hidden="true"
      />
      <div
        ref={ringRef}
        className="pointer-events-none fixed left-0 top-0 z-[9998] flex items-center justify-center rounded-full border border-hars-orange/70 transition-[width,height,background-color] duration-300"
        style={{
          width: active ? 64 : 34,
          height: active ? 64 : 34,
          marginLeft: active ? "-32px" : "-17px",
          marginTop: active ? "-32px" : "-17px",
          backgroundColor: active ? "rgba(240,116,42,0.12)" : "transparent",
        }}
        aria-hidden="true"
      >
        {active && label && (
          <span className="heading text-[9px] not-italic tracking-normal text-hars-orange">{label}</span>
        )}
      </div>
    </>
  );
}
